import type { SVGProps } from "react";

export function IconWhiteFinger(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M39.5001 18.5C39.5001 14.787 38.0251 11.226 35.3996 8.60051C32.774 5.975 29.2131 4.5 25.5001 4.5C21.787 4.5 18.2261 5.975 15.6006 8.6005C12.9751 11.226 11.5001 14.787 11.5001 18.5M21 42V18.5C21 16.0147 23.0148 14 25.5001 14C27.9854 14 30.0001 16.0147 30.0001 18.5V34.5C30.0001 32.5 31.5001 30 34.5001 30C37.5001 30 39.0001 32.5 39.0001 34.5C39.0001 32.5 40.5001 30 43.5001 30C46.5001 30 48.0001 32.5 48.0001 34.5C48.0001 32.5 49.5001 30 52.5001 30C55.5001 30 57.0001 32.5 57.0001 34.5V57H28.6275C24.384 57 20.3143 55.3143 17.3138 52.3138L14.5 49.5L4.5 39.5L5.84315 38.1569C8.96734 35.0327 14.0327 35.0327 17.1569 38.1569L21 42Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
